import * as z from "zod";

export const updateOrderReturnInfoFunction = {
  name: "updateOrderReturnInfoFunction" as const,
  input: z.object({ artifactId: z.string().optional() }),
  output: z.object({}),
};
